// Types
import { ButtonProps } from 'component-library/button'

type NavOption = {
  source: string
  label: string
  buttonVariant?: ButtonProps['variant']
}

export default {
  navOptions: [
    {
      source: 'https://www.proenem.com.br/',
      label: 'Home'
    },
    {
      source: 'https://www.proenem.com.br/#turmas',
      label: 'Cursos'
    },
    {
      source: 'https://www.proenem.com.br/#apostilas',
      label: 'Apostilas'
    },
    {
      source: 'https://www.proenem.com.br/#aprovados-slider',
      label: 'Aprovados'
    },
    {
      source: 'https://atendimento.proenem.com.br/',
      label: 'Dúvidas'
    }
  ] as NavOption[],
  content: [
    {
      label: 'Acessar Proenem',
      source: 'https://app.proenem.com.br',
      buttonVariant: 'secondary'
    },
    {
      label: 'Acessar Promedicina',
      source: 'https://app.promedicina.com.br',
      buttonVariant: 'info'
    }
  ] as NavOption[]
}
